import { render, staticRenderFns } from "./NovaSponsorModal.vue?vue&type=template&id=c8266088&scoped=true&"
import script from "./NovaSponsorModal.vue?vue&type=script&lang=ts&"
export * from "./NovaSponsorModal.vue?vue&type=script&lang=ts&"
import style0 from "./NovaSponsorModal.vue?vue&type=style&index=0&id=c8266088&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8266088",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('c8266088', component.options)
    } else {
      api.reload('c8266088', component.options)
    }
    module.hot.accept("./NovaSponsorModal.vue?vue&type=template&id=c8266088&scoped=true&", function () {
      api.rerender('c8266088', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/index/NovaSponsorModal.vue"
export default component.exports